import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './Button';
const LOGO = 'https://cdn.magicpatterns.com/uploads/atBL8cv61rZ8XfNmSHojX8/cropped-AllStar-White-Background.png';
const NAV_LINKS = [{
  label: 'Fiber Services',
  href: '#services'
}, {
  label: 'Why AllStar',
  href: '#why-us'
}, {
  label: 'About',
  href: '#about'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? 'border-b border-border bg-background/95 shadow-sm backdrop-blur' : 'bg-transparent'}`} data-id="element-116">
      <nav className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8" aria-label="Primary" data-id="element-117">
        <a href="#top" className="flex items-center" aria-label="AllStar Home Solutions home" data-id="element-118">
          <img src={LOGO} alt="AllStar Home Solutions" className="h-10 w-auto sm:h-11" data-id="element-119" />
        </a>

        <ul className="hidden items-center gap-8 lg:flex" data-id="element-120">
          {NAV_LINKS.map(link => <li key={link.href} data-id="element-121">
              <a href={link.href} className="text-sm font-medium text-foreground/80 transition-colors hover:text-brand-dark" data-id="element-122">
                {link.label}
              </a>
            </li>)}
        </ul>

        <Button asChild className="hidden bg-brand text-brand-foreground hover:bg-brand-dark lg:inline-flex" data-id="element-123">
          <a href="#contact" data-id="element-124">Check Availability</a>
        </Button>

        <button type="button" onClick={() => setOpen(value => !value)} className="inline-flex items-center justify-center rounded-md p-2 text-foreground lg:hidden" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-125">
          {open ? <X className="h-6 w-6" data-id="element-126" /> : <Menu className="h-6 w-6" data-id="element-127" />}
        </button>
      </nav>

      {open && <div className="border-t border-border bg-background lg:hidden" data-id="element-128">
          <ul className="space-y-1 px-4 py-4" data-id="element-129">
            {NAV_LINKS.map(link => <li key={link.href} data-id="element-130">
                <a href={link.href} onClick={() => setOpen(false)} className="block rounded-md px-3 py-2 text-base font-medium text-foreground/80 hover:bg-secondary hover:text-brand-dark" data-id="element-131">
                  {link.label}
                </a>
              </li>)}
            <li className="pt-2" data-id="element-132">
              <Button asChild className="w-full bg-brand text-brand-foreground hover:bg-brand-dark" data-id="element-133">
                <a href="#contact" onClick={() => setOpen(false)} data-id="element-134">
                  Check Availability
                </a>
              </Button>
            </li>
          </ul>
        </div>}
    </header>;
}